import type { TaskTrackerSummaryStatusFilter } from './taskTrackerBoardSummary.types'
import type { TaskTrackerStickerFilterDraftValue } from './taskTrackerBoard.stickerFilters.utils'
import type { TaskTrackerSummaryDeadlineFilterDraft } from './taskTrackerBoardSummaryDeadlineFilter.utils'

export type BoardSummaryStickerFilterDraftValue =
  | TaskTrackerStickerFilterDraftValue
  | TaskTrackerSummaryDeadlineFilterDraft

export type BoardSummaryFilterDraftValue =
  | TaskTrackerSummaryStatusFilter['value']
  | BoardSummaryStickerFilterDraftValue

export type BoardSummaryFilterDraftRow = {
  id: string
  filterType: 'status' | number | null
  value: BoardSummaryFilterDraftValue
}

export type BoardSummaryStickerFilterDraftRow = BoardSummaryFilterDraftRow

export const TASK_TRACKER_SUMMARY_STATUS_FILTER_OPTIONS: Array<{
  value: TaskTrackerSummaryStatusFilter['value']
  label: string
}> = [
  { value: 'completed', label: 'Выполнена' },
  { value: 'not_completed', label: 'Не выполнена' },
]

export const createBoardSummaryStickerFilterRowId = () =>
  `board-summary-filter-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

export const createEmptyBoardSummaryStickerFilterRow =
  (): BoardSummaryFilterDraftRow => ({
    id: createBoardSummaryStickerFilterRowId(),
    filterType: null,
    value: null,
  })

export const isBoardSummaryStatusFilterValue = (
  value: BoardSummaryFilterDraftValue | null | undefined,
): value is TaskTrackerSummaryStatusFilter['value'] =>
  value === 'completed' || value === 'not_completed'
